import React, { Component } from 'react';
import config from 'react-global-configuration';
// Importação do Router
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

const PropTypes = require('prop-types');

class RequestApi extends Component {
  // constructor
  constructor(props, context) {
    super(props, context);

    this.state = {
      client_id: config.get('client_id'),
      client_secret: config.get('client_secret'),
    }

    this.validate = this.validate.bind(this);
    this.handleErrors = this.handleErrors.bind(this);
    this.verifyPermission = this.verifyPermission.bind(this);
    this.normalizeResponse = this.normalizeResponse.bind(this);
  }


  normalizeResponse(responseJson) {
    var genericInternalError = 'Ocorreu um erro interno no sistema. Entre em contato com o suporte do sistema informando o horário (' + new Date().toISOString().slice(0, 19).replace('T', ' ') + ') e a tarefa executada';

    if (responseJson === null || typeof responseJson === 'undefined') {
      return {
        debug: 'error_reporting',
        status: 'error',
        message: genericInternalError,
      };
    }

    if (typeof responseJson !== 'object') {
      return {
        debug: 'error_reporting',
        status: 'error',
        message: genericInternalError,
      };
    }

    if (typeof responseJson.debug === 'undefined' && typeof responseJson.status === 'undefined' && typeof responseJson.message !== 'undefined') {
      responseJson['debug'] = 'error_reporting';
      responseJson['status'] = 'error';
      if (responseJson.message === 'Server Error') {
        responseJson['message'] = genericInternalError;
      }
    }

    return responseJson;
  }

  // Faço 4 verificações:
  // 1) Se houve resposta em json. Se não houve, houve erro na api e deve ser informado
  // 2) Se o sistema não está suspenso;
  // 3) se o usuário não está logado;
  // 4) se o usuário tem permissão para acessar a ação;
  validate(responseJson, mode, url) {
    responseJson = this.normalizeResponse(responseJson);
    // 1) Verifico se o houve erro
    /*
    if(typeof responseJson === 'undefined') {
        var storage = {
          alert_message: 'Houve um erro ao tentar processar os dados dessa página ou ação',
          alert_type: 'error',
        };
        localStorage.setItem("verify_message", JSON.stringify(storage));
        this.context.router.history.goBack();
    }
    */

    // 2) Verifico se o usuário está supenso
    if(typeof responseJson.suspended !== 'undefined') {
      this.context.router.history.push('/usuario/suspenso');
    }

    // 3) Verifico se o usuário está logado
    else if(typeof responseJson.error !== 'undefined') {
      this.context.router.history.push('/usuario/login');
    }

    // 4) Verifico se o usuário está logado
    else if(typeof responseJson.redirect_page !== 'undefined') {
      this.context.router.history.push('/usuario/login');
    }

    // 3) Verifico se o usuário não tem permisão
    else if(typeof responseJson.permission_denied !== 'undefined') {
      if(mode === 'url') {
        var storage = {
          alert_message: 'Seu usuário não tem permissão para acessar esta página.',
          alert_type: 'error',
        };
        localStorage.setItem("verify_message", JSON.stringify(storage));
        //this.context.router.history.goBack();
      }
      if(mode === 'alert') {
        responseJson['message'] = 'Seu usuário não tem permissão para acessar esta funcionalidade.';
        responseJson['status'] = 'error';
      }
    }

    // 5) Verifico se retornou algum bugreport
    if(typeof responseJson.debug !== 'undefined') {
      if(mode === 'url') {
        var storage = {
          alert_message: responseJson.message,
          alert_type: 'error',
        };
        localStorage.setItem("verify_message", JSON.stringify(storage));
        //this.context.router.history.goBack();
      }
      if(mode === 'alert') {
        responseJson['message'] = responseJson.message;
        responseJson['status'] = 'error';
      }
    }

    // 6) Verifico se retornou algum erro
    else if(responseJson.status === 'error') {
      if(mode === 'url') {
        var storage = {
          alert_message: responseJson.message,
          alert_type: responseJson.status,
        };
        localStorage.setItem("verify_message", JSON.stringify(storage));
        //this.context.router.history.push(url);
        throw 'invalida data';
      }
      if(mode === 'alert') {
        //window.history.back();
      }
    }
  }

  handleErrors(errors) {
  }

  verifyPermission(errors) {
  }

  header (type) {
    // busco as infos 
    var params = JSON.parse(localStorage.getItem("cid"));
    // Verifico se há algum storage setado
    if(params === null || typeof params === 'undefined') {
      this.context.router.history.push('/usuario/login');
    } else {
      // Verifico se o cid acode setado
      if(params.acode === null || typeof params.acode === 'undefined') {
        this.context.router.history.push('/usuario/login');
      } else {  
        if(this.props.handleLoaded !== null && typeof this.props.handleLoaded !== 'undefined') {
          this.props.handleLoaded(1);                
        }
        var auth = 'Bearer ' + params.acode;
        if (type === null || typeof type === 'undefined') {
          var header = {
            'Authorization': auth,
          };              
        } else {
          var header = {
            'Accept': type,
            'Content-Type': type,
            'Authorization': auth,
          };    
        }
        return header;
      }
    }
  }


  render() {
    return (
      <div></div>
    );
  }
}

RequestApi.contextTypes = {
  router: React.PropTypes.object.isRequired
}



export default RequestApi;



// WEBPACK FOOTER //
// ./src/Components/Miscelania/RequestApi.js